import { render, staticRenderFns } from "./PrismMarkup.vue?vue&type=template&id=fe717efe"
import script from "./PrismMarkup.vue?vue&type=script&lang=js"
export * from "./PrismMarkup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports